import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { ITableLargeColumnConfig } from 'projects/common/src/app/interfaces/table/table-large-column-config';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';

@Component({
  selector: 'app-total-charge-modal',
  templateUrl: './total-charge-modal.component.html',
  styleUrls: ['./total-charge-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TotalChargeModalComponent implements OnInit {
  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Input()
  public shift: string;
  @Input()
  public data: string[];

  public tableConfig: ITableConfig;

  constructor(
    private tableService: TableConfigService,
    public activeModal: NgbActiveModal,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  ngOnInit() {
    this.fillTableModal();
    let modal = {};
    if (this.title === 'Primeras Vueltas') {
      modal = {
        modal_widget: 'total-charge-first_loops',
      };
    } else {
      modal = {
        modal_widget: 'total-charge-last_loops',
      };
    }
    this.googleAnalyticsService.sendCustomEvent('modal', modal);
  }

  public setDatasetModalConfig(tableData: any[]): void {
    const customLargeColumns: ITableLargeColumnConfig[] = [
      { field: 'machine_name', isLargeColumn: true, flexGrow: 0.8 },
      { field: 'operator', isLargeColumn: true, flexGrow: 1.3 },
      { field: 'extraction', isLargeColumn: true, flexGrow: 0.8 },
      { field: 'dump', isLargeColumn: true, flexGrow: 0.8 },
      { field: 'finishTime', isLargeColumn: true, flexGrow: 1.3 },
    ];
    const headerParams: ITableHeaderParams = {
      data: tableData,
      replaceColumnName: [
        { prevName: 'machine', newName: 'device' },
        { prevName: 'startZone', newName: 'extraction' },
        { prevName: 'endZone', newName: 'dump' },
        { prevName: 'finishedAt', newName: 'finishtime' },
      ],
      excludeColumns: ['startedAt'],
      customLargeColumns,
    };

    const datasetParams: ITableDataParams = {
      tableData,
      dateConfig: [{ field: 'finishTime', format: 'date-time' }],
      excludeColumns: ['startedAt'],
      customLargeColumns,
    };

    const header = this.tableService.setHeaderConfig(headerParams);
    const dataset = this.tableService.setDatasetConfig(datasetParams);

    this.tableConfig = null;

    setTimeout(() => {
      this.tableConfig = { header, dataset };
    }, 0);
  }

  public fillTableModal(): void {
    this.setDatasetModalConfig(this.data);
  }
}
